<template>
  <div>
    <div class="content_title">
      Добавить услугу к шаблону договора
    </div>
    <div class="form-row">
      <div class="form-field">
        <label for="org-select">Выберите услугу из списка:</label>
        <select id="org-select" v-model="serviceId">
          <option
            v-for="(service, key) in services"
            :key="key"
            :value="service.ID"
          >
            {{ service.NAME }}
          </option>
        </select>
      </div>
    </div>
    <div class="main row">
      <div class="form-row">
        <div class="form-field">
          <b>Правила начислений</b>
        </div>
        <div class="form-field">
          <label for="sum-service-input">Стоимость услуги:</label>
          <input
            id="sum-service-input"
            v-model="newAccrualRule.SUM"
            type="number"
          />
        </div>
        <div class="form-field" v-show="!serviceRegular">
          <label for="install-input">Возможно предоставление рассрочки:</label>
          <select id="install-input" v-model="installments">
            <option value="Y">Да</option>
            <option value="N">Нет</option>
          </select>
        </div>
        <div
          class="form-field"
          v-show="installments === 'Y' && !serviceRegular"
        >
          <label for="month-input">Максимально месяцев рассрочки:</label>
          <input
            id="month-input"
            v-model="newAccrualRule.COUNT"
            type="number"
          />
        </div>
        <div class="form-field" v-show="!serviceRegular">
          <label for="prepayment-input">Возможна предоплата:</label>
          <select id="prepayment-input" v-model="prepayment">
            <option value="Y">Да</option>
            <option value="N">Нет</option>
          </select>
        </div>
        <div class="form-field" v-show="!serviceRegular && prepayment === 'Y'">
          <label for="presum-date-input">Сумма предоплаты:</label>
          <input
            id="presum-date-input"
            v-model="newAccrualRule.PREPAYMENT_SUM"
            type="number"
          />
        </div>
        <div class="form-field" v-show="serviceRegular">
          <label for="start-date-input">Начало периода:</label>
          <input
            id="start-date-input"
            v-model="newAccrualRule.DATE_START"
            type="number"
          />
        </div>
        <div class="form-field" v-show="serviceRegular">
          <label for="start-accrual-input">Старт подсчета:</label>
          <select
            id="start-accrual-input"
            v-model="newAccrualRule.DATE_ACCRUAL"
          >
            <option value="now">С текущей даты</option>
            <option value="start">С начала периода</option>
          </select>
        </div>
        <div class="form-field">
          <label for="fine-input">Взимать пени:</label>
          <select id="fine-input" v-model="penalty">
            <option value="Y">Да</option>
            <option value="N">Нет</option>
          </select>
        </div>
        <div class="form-field" v-show="serviceRegular">
          <label for="debt-input">Возможен долг по услуге:</label>
          <select id="debt-input" v-model="debt">
            <option value="Y">Да</option>
            <option value="N">Нет</option>
          </select>
        </div>
        <div class="form-field" >
          <label >Мин. баланс активной услуги:
            <input v-model="newAccrualRule.MIN_BALANCE" type="text" /></label>
        </div>
        <div class="form-field" v-show="!serviceRegular">
          <label>Передача собственности:
            <input v-model="newAccrualRule.CHANGE_OWNER" type="checkbox" /></label>
        </div>
      </div>
      <div class="form-row" v-show="penalty === 'Y'">
        <div class="form-field">
          <b>Параметры пени</b>
        </div>
        <div class="form-field">
          <label for="percent-input">Процент в день от суммы услуги:</label>
          <input
            id="percent-input"
            v-model="newPenalties.PERCENT"
            type="number"
          />
        </div>
        <div class="form-field">
          <label for="max-fine-input">Лимит начислений в процентах:</label>
          <input id="max-fine-input" v-model="newPenalties.MAX" type="number" />
        </div>
      </div>
      <div class="form-row" v-show="debt === 'Y'">
        <div class="form-field">
          <b>Параметры долга и блокировки</b>
        </div>
        <div class="form-field">
          <label for="debt-when-input">Считать долг через:</label>
          <input
            id="debt-when-input"
            v-model="newAccrualRule.DUE_DATE"
            type="number"
          />
        </div>
        <div class="form-field">
          <label for="court-input">Сумма долга для суда:</label>
          <input
            id="court-input"
            v-model="newDebtAndBlock.DEBT_FOR_COURT"
            type="number"
          />
        </div>
        <div class="form-field">
          <label for="sum-input">Сумма долга для блокировки:</label>
          <input
            id="sum-input"
            v-model="newDebtAndBlock.ACTIVE_TO_DEBT"
            type="number"
          />
        </div>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
    <div class="main row">
      <div class="form-row">
        <div class="form-field">
          <button @click="sendServiceData">Добавить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "ServicesAdd",
  data() {
    return {
      url: config.backend_url,
      serviceId: false,
      serviceData: {},
      services: [],
      penalty: "N",
      debt: "N",
      installments: "N",
      prepayment: "N",
      newAccrualRule: {},
      newPenalties: {},
      newDebtAndBlock: {},
      info: false
    };
  },
  computed: {
    serviceRegular: function() {
      return this.serviceId
        ? this.services[this.serviceId].REGULAR === "Y"
        : false;
    }
  },
  watch: {
    serviceId: function(newServiceId) {
      this.newAccrualRule.SERVICE = newServiceId;
      this.newPenalties.SERVICE = newServiceId;
      this.serviceData = this.services[this.serviceId];
    }
  },
  methods: {
    setDefaultData: function() {
      this.serviceId = false;
      this.penalty = "N";
      this.debt = "N";
      this.installments = "N";
      this.prepayment = "N";
      this.newAccrualRule = {
        SERVICE: null,
        SUM: null,
        DATE_START: null,
        COUNT: null,
        DUE_DATE: null,
        PREPAYMENT_SUM: null
      };
      this.newPenalties = {
        SERVICE: null,
        PERCENT: null,
        MAX: null
      };
      this.newDebtAndBlock = {
        DEBT_FOR_COURT: null,
        ACTIVE_TO_DEBT: null
      };
    },
    sendServiceData: function() {
      let { newAccrualRule, newPenalties, newDebtAndBlock, serviceData } = this;
      if (newAccrualRule.SERVICE && newAccrualRule.SUM) {
        serviceData.CAN_PENALTY = this.penalty;
        serviceData.CAN_DEBT = this.debt;
        this.$emit("service-add", {
          service: serviceData,
          accrualRule: newAccrualRule,
          penalties: newPenalties,
          debtAndBlock: newDebtAndBlock
        });
        this.setDefaultData();
      } else {
        alert("Необходимо заполнить все поля");
      }
    },
    getServices: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "services/get-user-services/",
          data: {},
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) this.services = data;
        });
    }
  },
  mounted() {
    this.setDefaultData();
    this.getServices();
  }
};
</script>
